import React, {createContext, useContext, useState} from 'react';

export const lowerSdkVersion = '0.18.5<=';
export const higherSdkVersion = '0.18.6>=';

export const sdkVersionsTab = {
  lowerSdkVersion: {label: 'SDK v0.18.5 or lower', value: lowerSdkVersion},
  higherSdkVersion: {label: 'SDK v0.18.6 or higher', value: higherSdkVersion},
};

type SDKVersionContextType = {
  sdkVersionValue: string;
  setSdkVersionValue: (value: string) => void;
};

const SDKVersionContext = createContext<SDKVersionContextType | undefined>(
  undefined
);

export const SDKVersionProvider: React.FC<{children: React.ReactNode}> = ({
  children,
}) => {
  const [sdkVersionValue, setSdkVersionValue] = useState(
    sdkVersionsTab.higherSdkVersion.value
  );
  return (
    <SDKVersionContext.Provider value={{sdkVersionValue, setSdkVersionValue}}>
      {children}
    </SDKVersionContext.Provider>
  );
};

export const useSDKVersion = () => {
  const context = useContext(SDKVersionContext);
  if (context === undefined) {
    throw new Error('useSDKVersion must be used within a SDKVersionProvider');
  }
  return context;
};
